/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * REQUIRED — the column is empty and the question needs it. INVALID_VALUE — not a value the column takes: an unknown type, a word other than TAK or NIE, a survey value outside 0–100, a tag taken out of use, an address other than http or https, a link next to a source that is not a procedure. TOO_LONG — longer than the bank stores. UNKNOWN_CATEGORY — no category in use has this name. KEY_TAKEN — a question in the bank already has the key. KEY_REPEATED — an earlier row of the file has it. UNKNOWN_KEY — a row of \"Źródła\" names a key no row of \"Pytania\" has. These three compare keys regardless of letter case: BHP-1 and bhp-1 are one key. RULE — the question breaks a rule the form enforces too; field names which. UNKNOWN_POSITION — no active position in the dictionary has this number or name. AMBIGUOUS_POSITION — the name is shared by several positions; positions lists them, and the cell should have the number of one instead.
 * @export
 * @enum {string}
 */

export const ImportErrorCodeDto = {
    Required: 'REQUIRED',
    InvalidValue: 'INVALID_VALUE',
    TooLong: 'TOO_LONG',
    UnknownCategory: 'UNKNOWN_CATEGORY',
    KeyTaken: 'KEY_TAKEN',
    KeyRepeated: 'KEY_REPEATED',
    UnknownKey: 'UNKNOWN_KEY',
    Rule: 'RULE',
    UnknownPosition: 'UNKNOWN_POSITION',
    AmbiguousPosition: 'AMBIGUOUS_POSITION'
} as const;

export type ImportErrorCodeDto = typeof ImportErrorCodeDto[keyof typeof ImportErrorCodeDto];



